import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/partsConstants';

const initialState = {
  parts: [],
  part: null,
  loading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const partsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_PARTS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_PART:
      return {
        ...state,
        part: null,
      };
    case types.GET_PARTS_SUCCESS:
      return {
        ...state,
        loading: false,
        parts: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_PARTS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_PARTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_PART:
      return {
        ...state,
        part: payload,
      };
    case types.SET_PARTS_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_PARTS_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_PARTS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_PARTS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default partsReducer;
